export default __webpack_public_path__ + "static/media/reenroll-cobra-checklist.f7fad9f6.svg";